module.exports = __webpack_public_path__ + "static/media/country_bm.480fe5ef.webp";